import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import SimpleButtonModal from '@components/SimpleButtonModal';
import sharedMessages from '@shared/messages';
import messages from './messages';

function ShopIsClosedModal({
  open,
  onClick,
  shopType,
  shopGender,
  isClosed,
  intl: { formatMessage },
}) {
  return (
    <SimpleButtonModal
      open={open}
      title={formatMessage(messages.title, { shopType, shopGender, isClosed })}
      subtitle={formatMessage(messages.subtitle, {
        shopType,
        shopGender,
        isClosed,
      })}
      secondText={formatMessage(sharedMessages.button_accept)}
      onSecondOptionClick={onClick}
      onClose={onClick}
      small
    />
  );
}

ShopIsClosedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  shopType: PropTypes.string,
  shopGender: PropTypes.string,
  isClosed: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  intl: intlShape,
};

export default injectIntl(ShopIsClosedModal);
